// extracted by mini-css-extract-plugin
export default {"tag":"tag-module--tag--2e4gN","isClickeable":"tag-module--is-clickeable--DF8N+","isSelected":"tag-module--is-selected--mBPmX"};